<template>
    <div class="p-grid" ref="top">
        <Toast />
        <div class="p-col-12">
            <div class="card p-fluid">
                <h4>
                    <strong>{{ $t('search.title') }}</strong>
                </h4>
                <div class="p-formgrid p-grid p-mb-3">
                    <div class="p-field p-col-12 p-md-3">
                        <label for="nameuser">{{ $t('notice1.list.Title') }}</label>
                        <InputText id="nameuser" type="text" :placeholder="$t('notice1.list.placeholder')" v-model="title" />
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label for="pass">{{ $t('notice1.list.CreatedDate') }}</label>
                        <Calendar :showIcon="true" :showButtonBar="true" v-model="created_date" dateFormat="yy.mm.dd" :placeholder="$t('notice1.list.Sdate')" :manualInput="false" :max-date="new Date()"> </Calendar>
                        <!-- <div class="text-red">{{ error.calendarValue }}</div> -->
                    </div>
                </div>
                <div class="p-d-flex p-jc-between p-ai-lg-center p-ai-start p-mt-6 p-flex-column p-flex-lg-row">
                    <div class="p-mb-4 p-mb-lg-0">
                        <!-- <Button :label="$t('button.today')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="today"></Button>
                        <Button :label="$t('button.lastWeek')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastweek"></Button>
                        <Button :label="$t('button.lastMonth')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastmonth"></Button>
                        <Button :label="$t('button.last6Months')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastsixmonth"></Button>
                        <Button :label="$t('button.lastYear')" icon="pi pi-calendar" iconPos="left" class="p-button p-button-outlined p-button-sm p-mr-2 p-mb-2" @click="lastyear"></Button> -->
                    </div>
                    <div>
                        <Button :label="$t('button.search')" icon="pi pi-search" iconPos="left" class="p-button p-component p-button p-button-sm p-mr-2 p-mb-2" @click="searchNotice"></Button>
                        <Button :label="$t('button.reset')" icon="pi pi-replay" iconPos="left" class="p-button p-component p-button p-button-sm p-mr-2 p-mb-2" @click="resetUser"></Button>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-col-12">
            <div class="card">
                <!-- <h5>{{ $t('table.userlist.heading') }}</h5> -->
                <h5>{{ $t('notice1.list.Header') }}</h5>
                <div class="p-d-flex p-jc-between p-ai-lg-center p-ai-start p-mb-2 p-flex-column p-flex-lg-row">
                    <!-- <div>
                        
                    </div> -->
                    <div class="p-mb-4 p-mb-lg-0 page">
                        <label for="order"
                            >{{ $t('notice1.list.Record') }}: {{ pagination.total_records }}
                            <Dropdown class="p-ml-2" id="order" v-model="pagination.pagination_limit" :options="pagination_limit_options" optionLabel="label" optionValue="value" placeholder="10개씩 보기" />
                        </label>
                    </div>
                    <div>
                        <router-link to="/add-notice">
                            <Button label="Primary" class="p-button p-component p-button p-button-sm p-mr-2 p-mb-2"> {{ $t('notice1.list.AddNew') }}</Button>
                        </router-link>
                    </div>
                </div>
                <br />
                <DataTable :value="results" :paginator="false" class="p-datatable-gridlines" :rows="10" dataKey="id" :rowHover="true" :loading="loading1" :filters="filters1" responsiveLayout="scroll">
                    <!-- v-model:selection="selected" -->
                    <ConfirmDialog group="dialog" />

                    <template #empty>문의를 찾을 수 없습니다</template>
                    <template #loading>어드민 정보 로딩중..</template>

                    <!-- <column selectionMode="multiple" style="width: 16px; text-align: center" /> -->
                    <Column field="name" :header="$t('notice1.list.No')" style="min-width: 3rem">
                        <template #body="{ index }">
                            <span class="p-column-title">No</span>
                            {{ pagination.current_page * pagination.pagination_limit - pagination.pagination_limit + (index + 1) }}
                        </template>
                    </Column>
                    <Column :header="$t('notice1.list.Title')" style="min-width: 12rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Title</span>
                            {{ data.title }}
                        </template>
                    </Column>
                    <Column :header="$t('notice1.list.Description')" style="width: 40%">
                        <template #body="{ data }">
                            <span class="p-column-title">Description</span>
                            <!-- <template class="p-column-title" v-if="data.description.length<8" v-html="data.description"></template>
                            <template class="p-column-title" v-else v-html="data.description.substring(0,8)"></template> -->
                            <span v-html="data.description"></span>
                        </template>
                    </Column>

                    <Column :header="$t('notice1.list.CreatedDate')" style="min-width: 7rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Date</span>
                            {{ FormatDate(data.create_date) }}
                        </template>
                    </Column>
                    <Column :header="$t('notice1.list.Action')" style="width: 5rem">
                        <template #body="{ data }">
                            <span class="p-column-title">Action</span>
                            <p style="display: none">{{ data.status }}</p>
                            <div style="display: flex">
                                <Button label="info" class="p-button2" @click="up(data.id)" :disabled="results.indexOf(data) == 0 ? true : false">
                                    <i class="pi pi-caret-up p-mr-2"></i>
                                </Button>

                                <Button label="info" class="p-button2" @click="down(data.id)" :disabled="results.length - 1 == results.lastIndexOf(data) ? true : false">
                                    <i class="pi pi-caret-down p-mr-2"></i>
                                </Button>
                                <router-link :to="'/view-notice/' + data.id"
                                    ><Button label="info" class="p-button2"><i class="pi pi-eye p-mr-2" id="eye"></i></Button>
                                </router-link>
                                <router-link :to="'/edit-notice/' + data.id" id="pen"
                                    ><Button label="help" class="p-button2"><i class="pi pi-pencil p-mr-2"></i></Button>
                                </router-link>

                                <Button icon="pi pi-trash" class="p-button2" @click="confirm(data.id)" />
                            </div>
                        </template>
                    </Column>
                </DataTable>
                <div class="p-paginator p-component p-paginator-bottom">
                    <button @click="paginate(1)" :class="{ 'p-disabled': pagination.current_page === 1 }" class="p-paginator-first p-paginator-element p-link" type="button" :disabled="pagination.current_page === 1">
                        <span class="p-paginator-icon pi pi-angle-double-left"></span>
                        <span class="p-ink"></span>
                    </button>
                    <button @click="paginate(pagination.current_page - 1)" :class="{ 'p-disabled': pagination.current_page === 1 }" class="p-paginator-next p-paginator-element p-link" type="button" :disabled="pagination.current_page === 1">
                        <span class="p-paginator-icon pi pi-angle-left"></span>
                        <span class="p-ink"></span>
                    </button>
                    <span class="p-paginator-pages">
                        <button
                            v-for="(page, index) in get_paginator_page(pagination.total_pages, pagination.current_page)"
                            :key="index"
                            @click="paginate(page)"
                            class="p-paginator-page p-paginator-element p-link"
                            :class="{ 'p-highlight': page === pagination.current_page }"
                            type="button"
                        >
                            {{ page }}<span class="p-ink"></span>
                        </button>
                    </span>
                    <button
                        @click="paginate(pagination.current_page + 1)"
                        :class="{ 'p-disabled': pagination.current_page === pagination.total_pages }"
                        class="p-paginator-next p-paginator-element p-link"
                        type="button"
                        :disabled="pagination.current_page === pagination.total_pages"
                    >
                        <span class="p-paginator-icon pi pi-angle-right"></span>
                        <span class="p-ink"></span>
                    </button>
                    <button
                        @click="paginate(pagination.total_pages)"
                        :class="{ 'p-disabled': pagination.current_page === pagination.total_pages }"
                        :disabled="pagination.current_page === pagination.total_pages"
                        class="p-paginator-last p-paginator-element p-link"
                        type="button"
                    >
                        <span class="p-paginator-icon pi pi-angle-double-right"></span>
                        <span class="p-ink"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { useRoute } from 'vue-router';
// import validateUsersearch from '../../validations/validateUserSearch';
// import { FilterMatchMode, FilterOperator } from 'primevue/api';
import NoticeService from '../../service/API/NoticeService';
import axios from 'axios';
import moment from 'moment';
import utils from '@/service/utils';
// import ProductService from '../service/ProductService';
// import axios from 'axios';
export default {
    data() {
        return {
            dropdownValues: [{ name: 'active', id: 1 }, { name: 'inactive' }],
            results: [],
            status: '',
            startdate: '',
            enddate: '',
            customer1: null,
            loading1: true,
            user: null,
            result: '',
            statuses: ['unqualified', 'qualified', 'new', 'negotiation', 'renewal', 'proposal'],
            dropdownItems: [
                { name: 'male', code: 'male' },
                { name: 'female', code: 'female' },
                { name: 'others', code: 'others' },
            ],
            dropdownItem: null,
            error: {},
            pagination_limit_options: [
                { label: '10개씩 보기', value: 10 },
                { label: '20개씩 보기', value: 20 },
                { label: '50개씩 보기', value: 50 },
                { label: '100개씩 보기', value: 100 },
            ],
            pagination: {
                current_page: 1,
                pagination_limit: 10,
                total_pages: 0,
                total_records: 0,
            },
            totalrecords: '',
            title: '',
            description: '',
            create_date: '',
            id: '',
            notice_id: '',
            created_date: '',
            FromDate: '',
        };
    },
    customerService: null,
    productService: null,
    created() {
        this.noticeService = new NoticeService();
        // this.title = localStorage.getItem('title')
        // this.created_date = localStorage.getItem('created_date') ? moment(localStorage.getItem('created_date')).format('YYYY-MM-DD') : ''
        // const params = {
        //     title: this.title,
        //     created_date: this.created_date,
        // };
        // this.callAPI(params);
    },
    mounted() {
        const route = useRoute();
        // this.getNClist();
        console.log(route.params);
        // this.noticeService.getNoticeList(this.title, this.status, this.startdate, this.enddate).then((data) => {
        //     this.customer1 = data;
        //     this.loading1 = false;
        //     this.customer1.forEach((customer) => (customer.createdDate = new Date(customer.createdDate)));
        // });
        this.storageData = localStorage.getItem('NoticeManagement') ? JSON.parse(localStorage.getItem('NoticeManagement')) : '';

        if (this.storageData != '') {
            this.NoticePagination = this.storageData.current_page;
            this.title = this.storageData.title == undefined ? '' : this.storageData.title;
            let FromDate = this.storageData.created_date ? new Date(this.storageData.created_date) : '';
            this.created_date = FromDate;
        }
        if (this.NoticePagination == '' || this.NoticePagination == null) {
            if (this.title || this.created_date) {
                const searchLocalParams = {
                    page: this.pagination.current_page,
                    limit: this.pagination.pagination_limit,
                    title: this.storageData.title == undefined ? '' : this.storageData.title,
                    created_date: this.storageData.created_date == undefined ? '' : this.storageData.created_date,
                };
                this.getNClist(searchLocalParams);
            } else {
                this.getNClist({ limit: this.pagination.pagination_limit, page: this.pagination.current_page });
            }
        } else {
            const searchLocalParams = {
                page: this.NoticePagination,
                limit: this.pagination.pagination_limit,
                title: this.storageData.title == undefined ? '' : this.storageData.title,
                created_date: this.storageData.created_date == undefined ? '' : this.storageData.created_date,
            };
            this.getNClist(searchLocalParams);
        }
    },
    watch: {
        'pagination.pagination_limit'(val) {
            this.getNClist({ limit: val, page: 1 });
        },
    },
    methods: {
        // callAPI(val) {

        // },
        getNClist(data) {
            // const NoticelistParams = {
            //     page: 1,
            //     limit: this.pagination.pagination_limit,
            // };
            // this.loading1 = true;
            this.noticeService
                .getNoticeList(data)
                .then((res) => {
                    this.results = res.data.result;
                    this.totalrecords = res.data.total_records;
                    this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                    this.loading1 = false;
                    // console.log(res);
                })
                .catch((err) => console.log(err));
            // this.callAPI(NoticelistParams);
            // this.noticeService
            //     .getNoticeList(NoticelistParams)
            //     .then((res) => {
            //         this.results = res.data.result;
            //         this.totalrecords = res.data.total_records;
            //         this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
            //         this.loading1 = false;
            //         console.log(res);
            //     })
            //     .catch((err) => console.log(err));
        },
        setPagination(current_page, total_pages, total_records) {
            this.pagination.current_page = current_page;
            this.pagination.total_pages = total_pages;
            this.pagination.total_records = total_records;
        },
        get_paginator_page(total, active) {
            return utils.paginate(total, active);
        },

        paginate(page) {
            this.loading1 = true;
            localStorage.setItem(
                'NoticeManagement',
                JSON.stringify({
                    current_page: page,
                    // limit: this.pagination.pagination_limit,
                    title: this.title,
                    created_date: this.FromDate,
                })
            );
            this.noticeService
                .getNoticeList({
                    page: page,
                    limit: this.pagination.pagination_limit,
                    title: this.title,
                    // created_date: this.created_date ? moment(this.created_date).format('YYYY-MM-DD') : '',
                    created_date: this.FromDate,
                })
                .then((res) => {
                    this.results = res.data.result;
                    this.pagination.current_page = page;
                    this.loading1 = false;
                    console.log(res.data);
                })
                .catch((err) => console.log(err));
        },
        up(ids) {
            axios({ method: 'post', url: 'api/v1/admin/notice/sort/up', data: { notice_id: ids } }).then(function (response) {
                console.log(response);
            });
            setTimeout(() => {
                this.noticeService.getNoticeList().then((res) => {
                    this.results = res.data.result;
                    console.log(res);
                    this.loading1 = false;
                });
            }, 500);
        },
        down(ids) {
            axios({ method: 'post', url: 'api/v1/admin/notice/sort/down', data: { notice_id: ids } }).then(function (response) {
                console.log(response);
            });
            setTimeout(() => {
                this.noticeService.getNoticeList().then((res) => {
                    this.results = res.data.result;
                    console.log(res);
                    this.loading1 = false;
                });
            }, 500);
        },

        selects() {
            let xyz = [];
            let data = this.selected;
            for (var a = 0; a < data.length; a++) {
                xyz.push(data[a].id);
            }
            this.selectedItemss = xyz.toString();
            if (this.calendarValue !== '') {
                this.calendarValue = this.calendarValue.toISOString().slice(0, 10);
                console.log(this.calendarValue);
            }
            if (this.calendarValue1 !== '') {
                this.calendarValue1 = this.calendarValue1.toISOString().slice(0, 10) + 1;
                console.log(this.calendarValue1);
            }
        },
        editnotice(id) {
            this.noticeService.viewNotice(id).then((result) => {
                localStorage.setItem('desc', JSON.stringify(result[0].description));
                // alert(res.result)
                // console.log(result[0].description)
            });
        },
        setData(id) {
            this.noticeService.viewNotice(id).then((res) => {
                // localStorage.setItem('desc', JSON.stringify(res.data.result[0]));
                alert(res.description);
            });
        },

        resetUser() {
            // localStorage.setItem('title', '');
            // localStorage.setItem('created_date', '');

            this.title = '';
            this.status = '';
            this.error = {};
            this.created_date = '';
            this.enddate = '';
            this.pagination.pagination_limit = '';
            localStorage.setItem('NoticeManagement', '');

            this.getNClist();
            window.location.reload();
        },
        addDay(val) {
            const date = new Date(val);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (val = yyyy + '.' + mm + '.' + dd);
        },
        searchNotice() {
            if (this.title == '' && this.created_date == '') {
                // console.log(this.productCategoryStatus);
                this.$toast.add({ severity: 'error', summary: '에러 메시지', detail: '1개 이상의 검색 값을 입력하세요.', life: 3000 });
            } else {
                // localStorage.setItem('title', this.title);
                // localStorage.setItem('created_date', this.created_date);

                if (this.created_date != '') {
                    this.FromDate = this.addDay(this.created_date);
                } else {
                    this.FromDate = '';
                }
                localStorage.setItem(
                    'NoticeManagement',
                    JSON.stringify({
                        current_page: 1,
                        // limit: this.pagination.pagination_limit,
                        title: this.title,
                        created_date: this.FromDate,
                    })
                );
                let searchParams = {
                    limit: this.pagination.pagination_limit,
                    page: 1,
                    title: this.title,
                    created_date: this.FromDate,
                };
                this.loading = true;
                // this.callAPI(searchParams);
                this.noticeService
                    .getNoticeList(searchParams)
                    .then((res) => {
                        this.results = res.data.result;
                        this.totalrecords = res.data.total_records;
                        this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                        this.loading1 = false;
                        // this.setPagination(res.data.current_page, res.data.total_pages === 0 ? 1 : res.data.total_pages, res.data.total_records);
                    })
                    .catch(() => {
                        this.results = [];
                        this.loading1 = false;
                    });
            }
        },
        today() {
            const utc = new Date().toJSON().slice(0, 10).replace(/-/g, '.');
            this.startdate = utc;
            this.enddate = utc;
        },
        lastweek() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 7);
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.getDate();
            this.startdate = startDate;
            this.enddate = edate;
        },
        lastmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 31);
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.getDate();
            this.startdate = startDate;
            this.enddate = edate;
        },
        lastsixmonth() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 182);
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.getDate();
            this.startdate = startDate;
            this.enddate = edate;
        },
        lastyear() {
            const date = new Date();
            const edate = new Date();
            date.setDate(date.getDate() - 365);
            const startDate = date.getFullYear() + '.' + (date.getMonth() + 1) + '.' + date.getDate();
            this.startdate = startDate;
            this.enddate = edate;
        },

        open() {
            this.display = true;
        },
        close() {
            this.display = false;
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },

        onRowExpand(event) {
            this.$toast.add({ severity: 'info', summary: 'Product Expanded', detail: event.data.name, life: 3000 });
        },
        onRowCollapse(event) {
            this.$toast.add({ severity: 'success', summary: 'Product Collapsed', detail: event.data.name, life: 3000 });
        },
        expandAll() {
            this.expandedRows = this.products.filter((p) => p.id);
            this.$toast.add({ severity: 'success', summary: 'All Rows Expanded', life: 3000 });
        },
        collapseAll() {
            this.expandedRows = null;
            this.$toast.add({ severity: 'success', summary: 'All Rows Collapsed', life: 3000 });
        },
        formatCurrency(value) {
            return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        },
        formatDate(value) {
            // return value.toLocaleDateString('en-US', {
            //     year: 'numeric',
            //     month: '2-digit',
            //     day: '2-digit',
            // });
            const date = new Date(value);
            var dd = date.getDate();
            var mm = date.getMonth() + 1;
            var yyyy = date.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            return (value = yyyy + '/' + mm + '/' + dd);
        },
        FormatDate(value) {
            if (value) {
                return moment(String(value)).format('YYYY.MM.DD');
            }
        },
        formatDateKO(value) {
            if (value) {
                return moment.utc(value).locale('ko').format('ll');
            }
        },
        calculateCustomerTotal(name) {
            let total = 0;
            if (this.customer3) {
                for (let customer of this.customer3) {
                    if (customer.representative.name === name) {
                        total++;
                    }
                }
            }

            return total;
        },

        confirm(id) {
            console.log(id);
            var self = this;
            this.$confirm.require({
                group: 'dialog',
                header: '확인',
                message: '삭제하시겠습니까?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: '삭제',
                rejectLabel: ' 취소',
                accept: () => {
                    axios({ method: 'post', url: `api/v1/admin/notice/delete`, data: { notice_id: id } }).then(function () {});
                    this.getNClist();
                    self.$toast.add({ severity: 'info', summary: '삭제', detail: '성공적으로 삭제되었습니다.', life: 3000 });
                    window.location.reload();
                },
                reject: () => {
                    // this.$toast.add({ severity: 'error', summary: '오류가 발생했습니다', detail: '취소되었습니다', life: 3000 });
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.p-datatable-tbody {
    .p-button {
        white-space: nowrap;
    }
}

.p-fluid {
    .p-button {
        width: auto;
    }
}

.p-button {
    background: white;
    // border: 1px solid blue;
    color: black;
}

// button.p-button.p-component.n-wrap.p-button2.p-mr-2.p-mb-2 {
//     background: black;
//     color: white;
// }

// .p-button2 {
//     background: white;
//     // border: 1px solid #0A0A0A;
//     color: black;
// }

// .p-button1 {
//     background-color: white;
//     color: black;
//     // border-color: black;
// }

// button.p-button.p-component.p-button3.p-mr-2.p-mb-2 {
//     height: 31px;
// }

// button.p-button.p-component.p-button2.p-component.p-button.p-button-sm.p-mr-2.p-mb-2 {
//     border: 1px solid blue;
//     color: black;
// }
</style>
